import generateMicrositeGradientColorsFromBase from '@web/components/microsite/generateMicrositeGradientColorsFromBase';
import { MicrositeBackgroundStyle } from '@web/enums/MicrositeBackgroundStyle';

export default (
  hex: string,
  backgroundStyle: MicrositeBackgroundStyle,
): string[] => {
  if (backgroundStyle === MicrositeBackgroundStyle.GRADIENT_UP) {
    return generateMicrositeGradientColorsFromBase(hex).reverse();
  }

  if (backgroundStyle === MicrositeBackgroundStyle.GRADIENT_DOWN) {
    return generateMicrositeGradientColorsFromBase(hex);
  }

  return [hex];
};
